function InputSearch({ value, onChange }) {
  return (
    <div className="bg-green-300 w-full h-24 flex justify-center items-center">
      <input
        className="bg-white w-full h-1/3 mx-4 py-2 rounded-lg px-3 focus:outline-none "
        placeholder="Cari Surah"
        value={value}
        onChange={(e) => onChange(e)}
      />
    </div>
  );
}

export default InputSearch;
